import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { LabelParticipantesConglomerado } from "./label-participantes-conglomerado.component";

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        LabelParticipantesConglomerado
    ],
    exports: [
        LabelParticipantesConglomerado
    ]
})
export class LabelParticipantesConglomeradoModule {}